//US 11866 - pure role matching for the FF Order Active toggle.
//CommonJS on purpose: the repo's jest has no babel transform, so only require()-able
//modules are unit-testable (see bookingTeamRoles.test.js).
const BOOKING_TEAM_ROLES = ['masteradmin', 'admin', 'logistics', 'freightforward']

const normalizeRole = r => r.toLowerCase().replace(/\s/g, '')

//Exact match after normalizing so 'freightforward customer' does NOT match 'freightforward'
const matchesBookingTeam = roles => {
  if (!roles) return false
  if (Array.isArray(roles)) return roles.some(r => BOOKING_TEAM_ROLES.includes(normalizeRole(r)))
  return BOOKING_TEAM_ROLES.includes(normalizeRole(roles))
}

module.exports = { BOOKING_TEAM_ROLES, normalizeRole, matchesBookingTeam }
